import { Component, HostBinding } from '@angular/core';

@Component({
    selector: 'lui-dialog-header',
    template: `
    <div class="dialog-header-body"><ng-content></ng-content></div>
    <ng-content select="[luiDialogClose]"></ng-content>
  `,
    standalone: false
})
export class DialogHeaderComponent {
  @HostBinding('class') hostClasses = ['lui-dialog-header', 'zone-dark'];
}
